import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  margin-bottom: 30px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  padding: 28px 13px 13px;

  position: relative;

  border-radius: ${theme.border.smallRadius};
  border: 1px solid #b9c1cb;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);

  & > button {
    position: absolute;
    right: 13px;
    background: transparent;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  //border: 1px solid #b9c1cb;
  border: none;
  background: ${theme.colors.white};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.gray700};
  resize: none;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #c4c4c4;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #c4c4c4;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #c4c4c4;
  }

  /* &::-webkit-scrollbar {
    height: 30px;
  } */
`;

export const Count = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  color: ${theme.colors.gray700};
  font-family: ${theme.font.montserrat};

  align-self: flex-end;
`;
